import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import styles from './NoListingsMessage.module.css';

export const NoListingsMessage = () => {
  const { T } = useIntl();

  return (
    <div className={styles.root}>
      <Typography className={CommonStyles.padding_bottom_1} variant="h5">
        {T("error_message.couldn't_find_results.heading")}
      </Typography>
      <Typography className={CommonStyles.padding_bottom_1} variant="body2">
        {T("error_message.couldn't_find_results.body")}
      </Typography>
    </div>
  );
};
